import './Workspace.css';
import React, { useEffect, useRef, useCallback } from 'react';
import {
    ReflexContainer,
    ReflexSplitter,
    ReflexElement
} from 'react-reflex';
import { connect } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { withTranslate } from 'react-redux-multilingual';
import { ReactSortable } from "react-sortablejs";
import Sortable, { MultiDrag } from 'sortablejs';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import InputBase from '@mui/material/InputBase';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import PlayCircleFilledWhiteOutlinedIcon from '@mui/icons-material/PlayCircleFilledWhiteOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import SaveIcon from '@mui/icons-material/Save';
import FormControl from '@mui/material/FormControl';
import Input from '@mui/material/Input';
import Divider from '@mui/material/Divider';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Collapse from '@mui/material/Collapse';
import SettingsIcon from '@mui/icons-material/Settings';
import Chip from '@mui/material/Chip';
import UndoIcon from '@mui/icons-material/Undo';
import RedoIcon from '@mui/icons-material/Redo';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CopyAllIcon from '@mui/icons-material/CopyAll';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import CreateNewFolderOutlinedIcon from '@mui/icons-material/CreateNewFolderOutlined';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Pagination from '@mui/material/Pagination';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import SmartToyTwoToneIcon from '@mui/icons-material/SmartToyTwoTone';
import ContentPasteGoIcon from '@mui/icons-material/ContentPasteGo';
import AddIcon from '@mui/icons-material/Add';
import BlockIcon from '@mui/icons-material/Block';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import ListAltTwoToneIcon from '@mui/icons-material/ListAltTwoTone';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import VisibilityIcon from '@mui/icons-material/Visibility';
import HistoryIcon from '@mui/icons-material/History';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import CircularProgress from '@mui/material/CircularProgress';
import CenterFocusStrongIcon from '@mui/icons-material/CenterFocusStrong';

import StepOptions from '../../blocks/StepOptions/StepOptions';
import SpecifyCalculationDialog from '../../blocks/SpecifyCalculationDialog/SpecifyCalculationDialog';
import ProjectsDialog from '../../blocks/ProjectsDialog/ProjectsDialog';
import ScriptsDialog from '../../blocks/ScriptsDialog/ScriptsDialog';
import HistoriesDetailsDialog from '../../blocks/HistoriesDetailsDialog/HistoriesDetailsDialog';
import ArrayDialog from '../../blocks/ArrayDialog/ArrayDialog';
import ObjectDialog from '../../blocks/ObjectDialog/ObjectDialog';

import Steps from '../../../libraries/Steps';

import {
    GetScripts,
    GetScriptName,
    GetProjects,
    CreateNewScript,
    UpdateScript,
    DeleteScript,
    DuplicateScript,
    GetScriptSteps,
    SaveScript,
    GetHistories,
    InspectSelector,
} from '../../../services/Workspace.service';

import { 
    IsObject 
} from '../../../libraries/Tool';

const innerHeight = window.innerHeight;
Sortable.mount(new MultiDrag());

function Workspace(props) {
    const { translate, SnackbarAlert, ConfirmDialog, BackDrop } = props;
    const navigate = useNavigate();
    const { scriptID } = useParams();

    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const [mode, setMode] = React.useState(1); // 1: Robot grid, 2: Robot workspace
    const [anchorPosition, setAnchorPosition] = React.useState(null);
    const [openStepOption, setOpenStepOption] = React.useState(false); 
    const [selectedItems, setSelectedItems] = React.useState([]);
    const [scriptsteps, setScriptsteps] = React.useState([]);
    const [categories, setCategories] = React.useState([]);
    const [scripts, setScripts] = React.useState([]);
    const [openCalculation, setOpenCalculation] = React.useState(false);
    const [searchStep, setSearchStep] = React.useState("");
    const [openProjects, setOpenProjects] = React.useState(false);
    const [searchScript, setSearchScript] = React.useState("");
    const [rowsPerPage, setRowsPerPage] = React.useState(50);
    const [pageCount, setPageCount] = React.useState(0);
    const [page, setPage] = React.useState(0);
    const [openScriptsDialog, setOpenScriptsDialog] = React.useState(false);
    const [projects, setProjects] = React.useState([]);
    const [openHistoriesDetails, setOpenHistoriesDetails] = React.useState(false);
    const [historiesMode, setHistoriesMode] = React.useState(0); // 1: Run scripts, 2: Debug scripts
    const [scriptstepsHistories, setScriptstepsHistories] = React.useState([]);
    const [errorSteps, setErrorSteps] = React.useState([]);
    const [openArray, setOpenArray] = React.useState(false);
    const [openObject, setOpenObject] = React.useState(false);
    const [histories, setHistories] = React.useState([]);
    const [showHistories, setShowHistories] = React.useState(false);
    const [openQuickBuilder, setOpenQuickBuilder] = React.useState(false);
    const [quickBuilder, setQuickBuilder] = React.useState({
        url: "",
        action: "click",
        text: "",
        loading: false,
        data: null,
        steps: [],
        error: ""
    });

    const indexRef = useRef();
    const newIndexRef = useRef();
    const dataScriptRef = React.useRef();
    const scriptNameRef = React.useRef();
    const scriptstepsHistoriesIndexRef = React.useRef(0);
    const scriptIDRef = React.useRef();
    const optionsRef = React.useRef({});
    const editedFlagRef = React.useRef(false);
    const hisInforRef = useRef({});

    const Icon = ({icon, color, bgColor}) => (
        <Box>
            <Box 
                component="i"
                className={"icon fa-solid" + (icon ? ` ${icon}` : "fa-robot")}
                sx={{ color: color, backgroundColor: bgColor }}
            ></Box>
        </Box>
    )

    const cloneStepByName = (name) => JSON.parse(JSON.stringify(Steps.find(step => step.name === name)));

    const quickStepTitle = (step) => {
        if(step?.name === 'openBrowser') return 'URLを開く';
        if(step?.name === 'click') return step?.title || 'クリック';
        if(step?.name === 'typeText') return step?.title || 'テキスト入力';
        if(step?.name === 'typePassword') return step?.title || 'パスワード入力';
        return step?.title || step?.name || '';
    }

    const quickStepDetail = (step) => {
        if(step?.name === 'openBrowser') return step?.options?.url?.value || '';
        if(step?.name === 'typeText') return step?.options?.text?.value || step?.options?.selector?.value || '';
        if(step?.name === 'typePassword') return step?.options?.selector?.value || '';
        return step?.options?.selector?.value || '';
    }

    const CustomDivider = ({index}) => {
        let divider = [];
        for(var i = 0; i < index; i++){
            divider.push(<Box component="div" className='divider' />);
        }
        return divider;
    }

    const CustomOptions = ({options}) => {
        let ops = [];
        let keys = Object?.keys(options);
        let hiddenValueObject = ["passwords"];
        for(let i = 0 ; i < keys.length ; i++) {
            let targetOption = options[keys[i]];
            if(targetOption.required) {
                ops.push(
                    <Box key={`custom-option-${i}`} className='step-options'>
                        {ops.length > 0 && <>&#59;</>}
                        <Box 
                            component="span" 
                            className='title'
                        >{translate(`${keys[i]?.toLowerCase()}`)}
                        </Box>
                        <Box 
                            component="span" 
                            className='value' 
                            title={
                                (hiddenValueObject.includes(keys[i]) && targetOption.value)
                                ? '********' 
                                : targetOption.value
                            }
                        >
                            {(hiddenValueObject.includes(keys[i]) && targetOption.value)
                            ? '********' 
                            : targetOption.value}
                        </Box>
                    </Box>
                )
            }
        }
        return <Box className='options'>{ops}</Box>
    }

    const onInit = ({ backDrop }) => {
        if(backDrop) props.dispatch({ type: 'UPDATE_BACKDROP', BackDrop: true });
        GetProjects()
        .then(res => {
            // console.log(res)
            setProjects(res.data.datas);
            GetScripts(searchScript, rowsPerPage, page)
            .then(res => {
                // console.log(res)
                setPageCount(Math.ceil(res.data.datas[0][0]?.count / rowsPerPage));
                setScripts(res.data.datas[1]);
            })
            .finally(() => {
                props.dispatch({ type: 'UPDATE_BACKDROP', BackDrop: false });
            })
        })
    }

    const handleChangeRowsPerPage = (event) => {
        setPage(0);
        setRowsPerPage(event.target.value);
    };
    const handleChangePage = (event, value) => {
        setPage(parseInt(value) - 1);
    };

    const getMaxNumOfOutputKey = (name, newList) => {
        let num = 0;
        newList.filter(step => step.name === name)?.map(step => {
            if(parseInt(step?.output.key?.split("_")[1]?.match(/\d+/g)?.join([])) > num) {
                num = parseInt(step?.output.key.split("_")[1]?.match(/\d+/g)?.join([]));
            }
        })
        return parseInt(num) + 1;
    }

    const setIndexOfScriptsteps = (newList) => {
        let index = 0, keys = [];
        for(let i = 0 ; i < newList.length ; i++){
            if(i > 0) {
                if(
                    ((newList[i-1].name === 'if' || newList[i-1].name === 'else') && (newList[i].name !== 'endif' && newList[i].name !== 'else')) ||
                    (newList[i-1].name === 'loop' && newList[i].name !== 'endloop') ||
                    (newList[i-1].name === 'foreach' && newList[i].name !== 'endforeach')
                ) {
                    index++;
                } else if(
                    ((newList[i].name === 'endif' || newList[i].name === 'else') &&  newList[i-1].name !== 'if' && newList[i-1].name !== 'else') ||
                    (newList[i].name === 'endloop' &&  newList[i-1].name !== 'loop') ||
                    (newList[i].name === 'endforeach' &&  newList[i-1].name !== 'foreach')
                ) {
                    index--;
                }
            }
            if(
                newList[i].name === 'if' || 
                newList[i].name === 'loop' || 
                newList[i].name === 'foreach'
                ) {
                keys[index] = newList[i].output.key;
            } else if(
                newList[i].name === 'else' || 
                newList[i].name === 'endif' || 
                newList[i].name === 'endloop' || 
                newList[i].name === 'endforeach'
                ) {
                newList[i].output.key = keys[index];
            }
            if(newList[i].index !== index){
                newList[i].index = index;
            }
        }
        setScriptsteps(JSON.parse(JSON.stringify(newList)));
    }
    const setList = (newList, sortable) => {
        // console.log(newList, sortable);
        if(sortable) setIndexOfScriptsteps(newList);
    }
    const onSelect = (evt) => {
        indexRef.current = Math.max(...evt.newIndicies.map(item => item.index)) || 0;
        setSelectedItems(evt.newIndicies.map(item => item.index).sort());
    }
    const onSort = (evt) => {
        editedFlagRef.current = true;
        if(evt.pullMode === "clone") {
            // when item is in another sortable
            newIndexRef.current =  evt.newIndex;
            scriptsteps[newIndexRef.current].title = translate(scriptsteps[newIndexRef.current].name.toLowerCase());
            if(scriptsteps[newIndexRef.current]?.output.key) {
                scriptsteps[newIndexRef.current].output.key += `_${getMaxNumOfOutputKey(scriptsteps[newIndexRef.current].name, scriptsteps)}`;
                if(["if", "loop", "foreach"].includes(scriptsteps[newIndexRef.current]?.name)) {
                    let newList = JSON.parse(JSON.stringify(scriptsteps));
                    let step = JSON.parse(JSON.stringify(Steps.find(step => step.name === `end${scriptsteps[newIndexRef.current]?.name}`)));
                    step.title = translate(step.name.toLowerCase())
                    newList.splice(newIndexRef.current + 1, 0, step);
                    newIndexRef.current = undefined;
                    setIndexOfScriptsteps(newList);
                }
            }
        }
        updateScriptstepsHistories(scriptsteps);
    }
    const handleOpenStepOption = () => {
        if(scriptsteps[indexRef.current].ignore) return;
        if(!anchorPosition) {
            setAnchorPosition({ x: ((window.innerWidth - 400) / 2), y: (150) });
        }
        setOpenStepOption(true);
    }
    const handleCloseStepOptions = (event) => {
        setOpenStepOption(false);
    };
    const handleAgreeStepOptions = (step, index) =>  {
        editedFlagRef.current = true;
        let newList = JSON.parse(JSON.stringify(scriptsteps));
        newList[index] = step;
        setIndexOfScriptsteps(newList);
        setOpenStepOption(false);
        updateScriptstepsHistories(newList);
    }

    const ensureQuickOpenBrowserStep = (steps, url) => {
        if(steps[0]?.name === 'openBrowser') {
            steps[0].options.url.value = url;
            steps[0].title = translate('openbrowser');
            return steps;
        }
        const openStep = cloneStepByName('openBrowser');
        openStep.title = translate('openbrowser');
        openStep.output.key = `$browser_${getMaxNumOfOutputKey('openBrowser', steps)}`;
        openStep.options.url.value = url;
        openStep.options.screenshot.value = true;
        return [openStep, ...steps];
    }

    const buildQuickPreviewSteps = (url) => {
        const openStep = cloneStepByName('openBrowser');
        openStep.title = translate('openbrowser');
        openStep.output.key = "$browser_1";
        openStep.options.url.value = url;
        openStep.options.screenshot.value = true;
        return [openStep];
    }

    const handleOpenQuickBuilder = (event) => {
        event?.currentTarget?.blur?.();
        setOpenQuickBuilder(true);
    }

    const handleQuickDisplay = async () => {
        if(!quickBuilder.url) {
            setQuickBuilder(prev => ({ ...prev, error: "URLを入力してください。" }));
            return;
        }
        setQuickBuilder(prev => ({ ...prev, loading: true, error: "", data: null }));
        try {
            const previewSteps = buildQuickPreviewSteps(quickBuilder.url);
            const res = await InspectSelector(quickBuilder.url, previewSteps, previewSteps.length, quickBuilder.action);
            if(res.data?.statusCd !== "SUCCESS") throw new Error(res.data?.output || "ページ表示に失敗しました。");
            setQuickBuilder(prev => ({ ...prev, loading: false, data: res.data, steps: previewSteps, error: "" }));
        } catch(error) {
            setQuickBuilder(prev => ({ ...prev, loading: false, data: null, steps: [], error: error?.response?.data?.output || error?.message || "ページ表示に失敗しました。" }));
        }
    }

    const handleQuickSelectElement = async (element) => {
        const currentPreviewSteps = quickBuilder.steps?.length ? JSON.parse(JSON.stringify(quickBuilder.steps)) : buildQuickPreviewSteps(quickBuilder.url);
        let newList = ensureQuickOpenBrowserStep(JSON.parse(JSON.stringify(scriptsteps)), quickBuilder.url);
        const stepName = quickBuilder.action === 'typePassword' ? 'typePassword' : quickBuilder.action === 'typeText' ? 'typeText' : 'click';
        const newStep = cloneStepByName(stepName);
        newStep.title = translate(stepName.toLowerCase());
        const elementText = (element.text || "").trim();
        if(elementText && stepName === 'click') newStep.title = `クリック: ${elementText}`;
        if(stepName === 'typeText') newStep.title = 'テキスト入力';
        if(stepName === 'typePassword') newStep.title = 'パスワード入力';
        newStep.options.browser.value = currentPreviewSteps[0]?.output?.key || "$browser_1";
        newStep.options.selector.value = element.selector;
        if(stepName === 'typeText') {
            newStep.options.text.value = quickBuilder.text;
        }
        if(stepName === 'typePassword') {
            newStep.options.passwords.value = quickBuilder.text;
        }
        if(newStep.options.screenshot) newStep.options.screenshot.value = true;
        currentPreviewSteps.push(JSON.parse(JSON.stringify(newStep)));
        newStep.options.browser.value = newList[0]?.output?.key || "$browser_1";
        newList.push(newStep);
        editedFlagRef.current = true;
        setIndexOfScriptsteps(newList);
        updateScriptstepsHistories(newList);
        setQuickBuilder(prev => ({ ...prev, loading: true, error: "" }));
        try {
            const res = await InspectSelector(quickBuilder.url, currentPreviewSteps, currentPreviewSteps.length, quickBuilder.action);
            if(res.data?.statusCd !== "SUCCESS") throw new Error(res.data?.output || "ページ更新に失敗しました。");
            setQuickBuilder(prev => ({ ...prev, loading: false, data: res.data, steps: currentPreviewSteps, error: "" }));
        } catch(error) {
            setQuickBuilder(prev => ({ ...prev, loading: false, steps: currentPreviewSteps, error: error?.response?.data?.output || error?.message || "ページ更新に失敗しました。" }));
        }
    }
    const handleChangeStepTitle = (e, index) => {
        let _scriptsteps = JSON.parse(JSON.stringify(scriptsteps));
        _scriptsteps[index].title = e.target.value;
        setScriptsteps(JSON.parse(JSON.stringify(_scriptsteps)));
    }
    const handleOpenCalculation = (index, step, name, value) =>  {
        optionsRef.current = { index, name, value };
        let newList = JSON.parse(JSON.stringify(scriptsteps));
        newList[index] = step;
        setIndexOfScriptsteps(newList);
        setOpenCalculation(true);
    }
    const handleCloseCalculation = () => {
        setOpenCalculation(false);
    }
    const handleAgreeCalculation = (options, calculation) => {
        handleCloseCalculation();
        editedFlagRef.current = true;
        let _scriptsteps = JSON.parse(JSON.stringify(scriptsteps));
        _scriptsteps[options.index]['options'][options.name].value = (calculation ? `fx(${calculation})` : '');
        setScriptsteps(JSON.parse(JSON.stringify(_scriptsteps)));
        updateScriptstepsHistories(_scriptsteps);
    }

    const handleOpenProjects = () =>  {
        setOpenProjects(true);
    }
    const handleCloseProjects = () => {
        setOpenProjects(false);
        onInit({ backDrop: false });
    }

    const filterCategories = (searchValue) => {
        return categories.filter(
            category => (filterSteps(category.name, searchValue))?.length > 0
        )
    }
    const filterSteps = (category, searchValue) => {
        return Steps.filter(
            step => step.category === category && 
            (
                (translate(`${step.name?.toLowerCase()}`).indexOf(searchValue.toLowerCase()) > -1) || 
                (translate(`${step.category?.toLowerCase()}`).indexOf(searchValue.toLowerCase()) > -1)
            )
        )
    }
    const handleOnChangeSearchStep = (e) => {
        setSearchStep(e.target.value);
    }

    const handleClickCategoryExpand = (index) => {
        let newCategories = [...categories];
        newCategories[index].expanded = !newCategories[index].expanded;
        setCategories(newCategories);
    }

    const handleClickAddNew = () => {
        dataScriptRef.current = undefined;
        setOpenScriptsDialog(true);
    }
    const handleClickAgree = async (script) => {
        // console.log(script)
        let event;
        if(!script?.scriptID) {
            setOpenScriptsDialog(false);
            event = CreateNewScript(script)
        } else if(script?.scriptID && script?.duplicateFlg) {
            setOpenScriptsDialog(false);
            event = DuplicateScript(script)
        } else {
            setOpenScriptsDialog(false);
            event = UpdateScript(script);
        }
        event?.then(res => {
            setTimeout(() => {
                props.dispatch({ 
                    type: 'UPDATE_SNACKBARALERT', 
                    SnackbarAlert: {
                        open: true,
                        severity: res?.data?.status,
                        message: translate(`${res?.data?.msg}`),
                        handleClose: () => handleCloseSnackbarAlert()
                    } 
                });
                onInit({ backDrop: true });
            }, 1000)
        })
        .catch(err => {
            setTimeout(() => {
                props.dispatch({ 
                    type: 'UPDATE_SNACKBARALERT', 
                    SnackbarAlert: {
                        open: true,
                        severity: err?.response?.data?.status,
                        message: translate(`${err?.response?.data?.msg}`),
                        handleClose: () => handleCloseSnackbarAlert()
                    } 
                });
            }, 1000)
        })
    }
    const handleClickClose = () => {
        dataScriptRef.current = undefined;
        setOpenScriptsDialog(false);
    }

    const handleClickOpenProjects = () => {
        setOpenProjects(true)
    }

    const handleCloseSnackbarAlert = () => {
        props.dispatch({ type: 'UPDATE_SNACKBARALERT', SnackbarAlert: { ...SnackbarAlert, open: false } });
    }
    
    const onCloseConfirmDialog = () => {
        props.dispatch({ type: 'UPDATE_CONFIRMDIALOG', ConfirmDialog: {...ConfirmDialog, open: false} });
    }
    
    const onAgreeConfirmDelete = (scriptID) => {
        onCloseConfirmDialog();
        DeleteScript(scriptID)
        .then(res => {
            setTimeout(() => {
                props.dispatch({ 
                    type: 'UPDATE_SNACKBARALERT', 
                    SnackbarAlert: {
                        open: true,
                        severity: res?.data?.status,
                        message: translate(`${res?.data?.msg}`),
                        handleClose: () => handleCloseSnackbarAlert()
                    } 
                });
                onInit({ backDrop: true });
            }, 1000)
        })
        .catch(err => {
            setTimeout(() => {
                props.dispatch({ 
                    type: 'UPDATE_SNACKBARALERT', 
                    SnackbarAlert: {
                        open: true,
                        severity: err?.response?.data?.status,
                        message: translate(`${err?.response?.data?.msg}`),
                        handleClose: () => handleCloseSnackbarAlert()
                    } 
                });
            }, 1000)
        })
    }

    const onAgreeConfirmRun = (scriptID) => {
        scriptIDRef.current = scriptID;
        GetScriptSteps(scriptID)
        .then(res => {
            // console.log(res)
            setScriptsteps(res.data.datas);
            runScripts();
        })
        onCloseConfirmDialog();
    }

    const handleOpenHistoriesDetails = () =>  {
        setOpenHistoriesDetails(true);
    }
    const handleCloseHistoriesDetails = () => {
        handleGetHistories();
        setOpenHistoriesDetails(false);
    }

    const handleClickAction = useCallback(
        async (name, ID) => {
            let _scriptsteps;
            switch (name) {
                case 'build':
                    navigate(`/control-center/workspace/${ID}`);
                    // window.open(`/control-center/workspace/${ID}`, "_blank");
                    break;
                case 'update':
                    dataScriptRef.current = {...scripts.find(script => script.scriptID === ID)};
                    setOpenScriptsDialog(true);
                    break;
                case 'duplicate':
                    dataScriptRef.current = {...scripts.find(script => script.scriptID === ID)};
                    dataScriptRef.current.duplicateFlg = true;
                    dataScriptRef.current.name += ' copy';
                    setOpenScriptsDialog(true);
                    break;
                case 'delete':
                    setAnchorElUser(null);
                    props.dispatch({ 
                        type: 'UPDATE_CONFIRMDIALOG', 
                        ConfirmDialog: {
                            open: true,
                            title: translate('delete'),
                            message: translate('deletescriptconfirm', { scriptName: (scripts.find(script => script.scriptID === ID)).name }),
                            buttonName: translate('delete'),
                            scriptID: ID,
                            onClose: () => onCloseConfirmDialog(),
                            onAgree: () => onAgreeConfirmDelete(ID)
                        } 
                    });
                    break;
                case 'run':
                    setAnchorElUser(null);
                    props.dispatch({ 
                        type: 'UPDATE_CONFIRMDIALOG', 
                        ConfirmDialog: {
                            open: true,
                            title: translate('run'),
                            message: translate('runscriptconfirm', { scriptName: (scripts.find(script => script.scriptID === ID)).name }),
                            buttonName: translate('run'),
                            scriptID: ID,
                            onClose: () => onCloseConfirmDialog(),
                            onAgree: () => onAgreeConfirmRun(ID)
                        } 
                    });
                    break;
                case 'back':
                    if(editedFlagRef.current) {
                        setAnchorElUser(null);
                        props.dispatch({ 
                            type: 'UPDATE_CONFIRMDIALOG', 
                            ConfirmDialog: {
                                open: true,
                                title: translate('notice'),
                                message: translate('gobackconfirm'),
                                buttonName: translate('save'),
                                scriptID: ID,
                                onClose: () => {
                                    onCloseConfirmDialog();
                                    handleGoToWorkspace();
                                },
                                onAgree: async () => {
                                    onCloseConfirmDialog();
                                    if(
                                        !await validateScriptstepsMissing() ||
                                        !await validateScriptstepsOptions()
                                    ) return;
                                    handleClickAction('save');
                                    handleGoToWorkspace();
                                }
                            } 
                        });
                    } else {
                        handleGoToWorkspace();
                    }
                    break;
                case 'save':
                    if(
                        !await validateScriptstepsMissing() ||
                        !await validateScriptstepsOptions()
                    ) return;
                    props.dispatch({ type: 'UPDATE_BACKDROP', BackDrop: true });
                    SaveScript(scriptID, scriptsteps)
                    .then(res => {
                        editedFlagRef.current = false;
                        setTimeout(() => {
                            props.dispatch({ type: 'UPDATE_BACKDROP', BackDrop: false });
                            props.dispatch({ 
                                type: 'UPDATE_SNACKBARALERT', 
                                SnackbarAlert: {
                                    open: true,
                                    severity: res?.data?.status,
                                    message: translate(`${res?.data?.msg}`),
                                    handleClose: () => handleCloseSnackbarAlert()
                                } 
                            });
                        }, 500)
                    })
                    .catch(err => {
                        setTimeout(() => {
                            props.dispatch({ type: 'UPDATE_BACKDROP', BackDrop: false });
                            props.dispatch({ 
                                type: 'UPDATE_SNACKBARALERT', 
                                SnackbarAlert: {
                                    open: true,
                                    severity: err?.response?.data?.status,
                                    message: translate(`${err?.response?.data?.msg}`),
                                    handleClose: () => handleCloseSnackbarAlert()
                                } 
                            });
                        }, 500)
                    })
                    break;
                case 'undo-step':
                    if(scriptstepsHistoriesIndexRef.current > 0) {
                        editedFlagRef.current = true;
                        scriptstepsHistoriesIndexRef.current -= 1;
                        let _scriptstepsHistories= JSON.parse(JSON.stringify(scriptstepsHistories));
                        let _scriptsteps = JSON.parse(JSON.stringify(_scriptstepsHistories[scriptstepsHistoriesIndexRef.current]));
                        setScriptsteps(JSON.parse(JSON.stringify(_scriptsteps)));
                    }
                    break;
                case 'delete-step':
                    if(selectedItems.length > 0) {
                        editedFlagRef.current = true;
                        if(openStepOption) setOpenStepOption(false);
                        let _scriptsteps = scriptsteps.filter((step, index) => !selectedItems.includes(index));
                        setScriptsteps(JSON.parse(JSON.stringify(_scriptsteps)));
                        updateScriptstepsHistories(_scriptsteps);
                    }
                    break;
                case 'copy-step':
                    if(selectedItems.length > 0) {
                        _scriptsteps = scriptsteps.filter((step, index) => selectedItems.includes(index));
                        navigator.clipboard.writeText(JSON.stringify(_scriptsteps));
                        props.dispatch({ 
                            type: 'UPDATE_SNACKBARALERT', 
                            SnackbarAlert: {
                                open: true,
                                severity: 'success',
                                message: translate('copiedtoclipboard'),
                                handleClose: () => handleCloseSnackbarAlert()
                            } 
                        });
                    }
                    break;
                case 'paste-step':
                    let steps = await navigator.clipboard.readText();
                    if(IsObject(steps)) {
                        editedFlagRef.current = true;
                        steps = JSON.parse(steps);
                        for(let i = 0 ; i < steps.length ; i++) {
                            let _step = Steps.find(step => step.category === steps[i].category && step.name === steps[i].name);
                            steps[i].output.key = `${_step.output.key}_${getMaxNumOfOutputKey(steps[i].name, scriptsteps)}`;
                        }
                        let _scriptsteps = JSON.parse(JSON.stringify(scriptsteps));
                        _scriptsteps.splice(parseInt(Math.max.apply(Math, selectedItems)) + 1, 0, ...steps);
                        setIndexOfScriptsteps(_scriptsteps);
                        setSelectedItems(Array.from(new Array(steps.length), (x, i) => (i + ((Math.max.apply(Math, selectedItems)) + 1))));
                        setScriptsteps(JSON.parse(JSON.stringify(_scriptsteps)));
                        updateScriptstepsHistories(_scriptsteps);
                    }
                    break;
                case 'disable-step':
                    if(selectedItems.length > 0) {
                        editedFlagRef.current = true;
                        _scriptsteps = scriptsteps.map((step, index) => {
                            if((step?.ignore !== undefined) && selectedItems.includes(index)) step.ignore = !step.ignore;
                            return step;
                        })
                        setScriptsteps(JSON.parse(JSON.stringify(_scriptsteps)));
                        updateScriptstepsHistories(_scriptsteps);
                    }
                    break;
                case 'redo-step':
                    if(scriptstepsHistoriesIndexRef.current < (scriptstepsHistories.length - 1)) {
                        editedFlagRef.current = true;
                        scriptstepsHistoriesIndexRef.current += 1;
                        let _scriptstepsHistories= JSON.parse(JSON.stringify(scriptstepsHistories));
                        let _scriptsteps = JSON.parse(JSON.stringify(_scriptstepsHistories[scriptstepsHistoriesIndexRef.current]));
                        setScriptsteps(JSON.parse(JSON.stringify(_scriptsteps)));
                    }
                    break;
                case "show-histories":
                    setShowHistories(!showHistories);
                    break;
            }
        }, [scriptID, scripts, scriptsteps, selectedItems, scriptstepsHistories, showHistories],
    );

    const validateScriptstepsMissing = () => {
        return new Promise((resolve, reject) => {
            let _errorIs, _msg = "";
            // If step
            if(scriptsteps.filter(step => step.name === 'if').length > scriptsteps.filter(step => step.name === 'endif').length) {
                _errorIs = true;
                _msg = 'msg_missingendifstep';
            } else if (scriptsteps.filter(step => step.name === 'if').length < scriptsteps.filter(step => step.name === 'endif').length) {
                _errorIs = true;
                _msg = 'msg_missingifstep';
            } else if (scriptsteps.filter(step => step.name === 'if')?.reduce( ( sum, { index } ) => sum + index , 0) !== scriptsteps.filter(step => step.name === 'endif')?.reduce( ( sum, { index } ) => sum + index , 0)) {
                _errorIs = true;
                _msg = 'msg_invalidscriptstep';
            }
            // Loop step
            if(scriptsteps.filter(step => step.name === 'loop').length > scriptsteps.filter(step => step.name === 'endloop').length) {
                _errorIs = true;
                _msg = 'msg_missingendloopstep';
            } else if (scriptsteps.filter(step => step.name === 'loop').length < scriptsteps.filter(step => step.name === 'endloop').length) {
                _errorIs = true;
                _msg = 'msg_missingloopstep';
            } else if (scriptsteps.filter(step => step.name === 'loop')?.reduce( ( sum, { index } ) => sum + index , 0) !== scriptsteps.filter(step => step.name === 'endloop')?.reduce( ( sum, { index } ) => sum + index , 0)) {
                _errorIs = true;
                _msg = 'msg_invalidscriptstep';
            }
            // For-Each step
            if(scriptsteps.filter(step => step.name === 'foreach').length > scriptsteps.filter(step => step.name === 'endforeach').length) {
                _errorIs = true;
                _msg = 'msg_missingendforeachstep';
            } else if (scriptsteps.filter(step => step.name === 'foreach').length < scriptsteps.filter(step => step.name === 'endforeach').length) {
                _errorIs = true;
                _msg = 'msg_missingforeachstep';
            } else if (scriptsteps.filter(step => step.name === 'foreach')?.reduce( ( sum, { index } ) => sum + index , 0) !== scriptsteps.filter(step => step.name === 'endforeach')?.reduce( ( sum, { index } ) => sum + index , 0)) {
                _errorIs = true;
                _msg = 'msg_invalidscriptstep';
            }
            if(_errorIs) {
                props.dispatch({ 
                    type: 'UPDATE_SNACKBARALERT', 
                    SnackbarAlert: {
                        open: true,
                        severity: "error",
                        message: translate(_msg),
                        handleClose: () => handleCloseSnackbarAlert()
                    } 
                });
                resolve(false);
            }
            resolve(true)
        })
    }

    const validateScriptstepsOptions = () =>  {
        return new Promise((resolve, reject) => {
            setErrorSteps([]);
            let _errorIs, _errorSteps = [];
            scriptsteps.map((step, index) => {{
                if(step.ignore === false) {
                    let options = Object.keys(step?.options || []);
                    for (let key of options) {
                        if(
                            step.options[key].required === true && 
                            (
                                step.options[key].value === "" ||
                                step.options[key].value === undefined
                            )
                        ) {
                            _errorIs = true;
                            _errorSteps.push(index);
                        }
                    }
                }
            }})
            if(_errorIs) {
                setErrorSteps(_errorSteps);
                props.dispatch({ 
                    type: 'UPDATE_SNACKBARALERT', 
                    SnackbarAlert: {
                        open: true,
                        severity: "error",
                        message: translate('msg_pleaseenterthedataintherequiredfield'),
                        handleClose: () => handleCloseSnackbarAlert()
                    } 
                });
                resolve(false);
            }
            resolve(true);
        })
    }

    const updateScriptstepsHistories = (_scriptsteps) => {
        let _scriptstepsHistories = JSON.parse(JSON.stringify(scriptstepsHistories));
        _scriptstepsHistories.push(_scriptsteps);
        scriptstepsHistoriesIndexRef.current = _scriptstepsHistories.length - 1;
        setScriptstepsHistories(_scriptstepsHistories);
    }

    const runScripts = async () => {
        if(
            (scriptsteps.lenght === 0) ||
            !await validateScriptstepsMissing() ||
            !await validateScriptstepsOptions()
        ) return;
        setHistoriesMode(1);
        handleOpenHistoriesDetails();
    }

    const handleOpenArray = (index, step, name, value) => {
        optionsRef.current = { index, name, value };
        let newList = JSON.parse(JSON.stringify(scriptsteps));
        newList[index] = step;
        setIndexOfScriptsteps(newList);
        setOpenArray(true);
    }

    const handleCloseArray = () => {
        setOpenArray(false);
    }

    const handleAgreeArray = (index, name, value) =>  {
        let _scriptsteps = JSON.parse(JSON.stringify(scriptsteps));
        _scriptsteps[index].options[name].value = `[${value?.map((item) => `"${item}"`)}]`;
        setScriptsteps(_scriptsteps);
        updateScriptstepsHistories(_scriptsteps);
        handleCloseArray();
    }

    const handleOpenObject = (index, step, name, value) => {
        optionsRef.current = { index, name, value };
        let newList = JSON.parse(JSON.stringify(scriptsteps));
        newList[index] = step;
        setIndexOfScriptsteps(newList);
        setOpenObject(true);
    }

    const handleCloseObject = () => {
        setOpenObject(false);
    }

    const handleAgreeObject = (index, name, value) =>  {
        let _scriptsteps = JSON.parse(JSON.stringify(scriptsteps));
        _scriptsteps[index].options[name].value = JSON.stringify(value.reduce((obj, item) => Object.assign(obj, { [item.key]: item.value }), {}));
        setScriptsteps(_scriptsteps);
        updateScriptstepsHistories(_scriptsteps);
        handleCloseObject();
    }

    const handleGoToWorkspace = () => {
        setSearchStep("");
        setOpenStepOption(false);
        navigate(`/control-center/workspace`);
    }

    const handleViewHistoriesDetails = (histories) => {
        setHistoriesMode(3);
        hisInforRef.current.statusCd = histories.statusCd;
        hisInforRef.current.historiesID = histories.historiesID;
        // scriptIDRef.current = histories.scriptID;
        // scriptNameRef.current = histories.scriptName;
        handleOpenHistoriesDetails(true);
    }

    const handleGetHistories = () => {
        GetHistories(scriptID)
        .then(res => {
            // console.log(res)
            setHistories(res.data.datas);
        })
    }

    useEffect(() => {
        if(scriptID) {
            editedFlagRef.current = false;
            props.dispatch({ type: 'UPDATE_BACKDROP', BackDrop: true });
            setMode(2);
            // Get Script Name
            GetScriptName(scriptID)
            .then(res => {
                scriptNameRef.current = res.data?.name;
                // Get Steps
                GetScriptSteps(scriptID)
                .then(res => {
                    setScriptsteps(res.data.datas);
                    setScriptstepsHistories([res.data.datas]);
                    handleGetHistories();
                })
                .catch (e => {
                    navigate(`/control-center/workspace`);
                })
                .finally(() => {
                    props.dispatch({ type: 'UPDATE_BACKDROP', BackDrop: false });
                })
            })
            .catch (e => {
                navigate(`/control-center/workspace`);
            })
            .finally(() => {
                props.dispatch({ type: 'UPDATE_BACKDROP', BackDrop: false });
            })
        } else {
            scriptNameRef.current = "";
            newIndexRef.current = undefined;
            setMode(1);
            setScriptsteps([]);
            setScriptstepsHistories([]);
            setOpenStepOption(false);
        }
    }, [scriptID]);

    useEffect(() => {
        setCategories(
            Steps.filter(
                (v,i,a) => a.findLastIndex(t => (t.category === v.category)) === i)?.map(item => ( { name: item.category, expanded: true } )
            )
        );
    }, [])

    useEffect(() => {
        const getData = setTimeout(() => {
            onInit({ backDrop: false });
        }, 500)
        return () => clearTimeout(getData)

    }, [searchScript, rowsPerPage, page]);

    useEffect(() => {
        props.dispatch({ type: 'UPDATE_BACKDROP', BackDrop: true });
    }, [])

    return (
        <Container maxWidth="xl">
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Box className='workspace-box'>
                        <Box xs={12}>
                            {mode === 1 && 
                            <Box sx={{ 
                                    p: 1, 
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    borderBottom: '1px solid rgb(229, 234, 242)'
                                }}
                            >
                                <Box className='search-box'>
                                    <IconButton type="submit" sx={{ p: '10px' }} aria-label="search">
                                        <SearchIcon />
                                    </IconButton>
                                    <InputBase
                                        type="search"
                                        sx={{ ml: 1, flex: 1 }}
                                        placeholder={translate('search')}
                                        onChange={(e) => setSearchScript(e.target.value) }
                                        value={searchScript}
                                    />
                                </Box>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                                    <Box>
                                        <Button variant="contained" disableElevation startIcon={<CreateNewFolderOutlinedIcon />} color="info" onClick={handleOpenProjects}>{translate('projects')}</Button>
                                    </Box>
                                    <Box>
                                        <Button variant="contained" disableElevation startIcon={<AddIcon />} onClick={handleClickAddNew}>{translate('addnew')}</Button>
                                    </Box>
                                </Box>
                            </Box>}
                            {mode === 2 && 
                            <Box sx={{ 
                                    p: 1, 
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    borderBottom: '1px solid rgb(229, 234, 242)'
                                }}>
                                <Box sx={{ flex: 1, display: "flex", justifyContent: "left", alignItems: "center", gap: 2 }}>
                                    <Tooltip title={translate('back')}>
                                        <IconButton className='action-button' size="small" onClick={() => handleClickAction('back')}>
                                            <KeyboardBackspaceIcon color='secondary' />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                                <Box sx={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center", gap: 2 }}>
                                    <Tooltip title={translate('undo')}>
                                        <IconButton className='action-button' size="small" disabled={scriptstepsHistoriesIndexRef.current === 0} onClick={() => handleClickAction('undo-step')}>
                                            <UndoIcon color={scriptstepsHistoriesIndexRef.current === 0 ? 'disabled' : 'secondary'} />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title={translate('delete')}>
                                        <IconButton className='action-button' size="small" disabled={selectedItems.length === 0 || scriptsteps.length === 0} onClick={() => handleClickAction('delete-step')}>
                                            <DeleteOutlineIcon color={selectedItems.length === 0 || scriptsteps.length === 0 ? 'disabled' : 'error'} />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title={translate('copy')}>
                                        <IconButton className='action-button' size="small" disabled={selectedItems.length === 0 || scriptsteps.length === 0} onClick={() => handleClickAction('copy-step')}>
                                            <CopyAllIcon color={selectedItems.length === 0 || scriptsteps.length === 0 ? 'disabled' : 'info'} />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title={translate('paste')}>
                                        <IconButton className='action-button' size="small" onClick={() => handleClickAction('paste-step')}>
                                            <ContentPasteGoIcon color={'warning'} />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title={`${translate('disable')}/${translate('enable')}` }>
                                        <IconButton className='action-button' size="small" disabled={selectedItems.length === 0 || scriptsteps.length === 0} onClick={() => handleClickAction('disable-step')}>
                                            <BlockIcon color={selectedItems.length === 0 || scriptsteps.length === 0 ? 'disabled' : '#35323'} />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title={translate('redo')}>
                                        <IconButton className='action-button' size="small" disabled={!(scriptstepsHistoriesIndexRef.current < (scriptstepsHistories.length - 1))} onClick={() => handleClickAction('redo-step')}>
                                            <RedoIcon color={!(scriptstepsHistoriesIndexRef.current < (scriptstepsHistories.length - 1)) ? 'disabled' : 'secondary'} />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                                <Box sx={{ flex: 1, display: "flex", justifyContent: "end", alignItems: "center", gap: 2 }}>
                                    <Tooltip title="かんたん作成">
                                        <IconButton className='action-button' size="small" onClick={handleOpenQuickBuilder}>
                                            <CenterFocusStrongIcon color="primary" />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title={translate('run')}>
                                        <IconButton className='action-button' size="small" disabled={scriptsteps.length === 0} onClick={runScripts}>
                                            <PlayCircleFilledWhiteOutlinedIcon color={scriptsteps.length === 0 ? 'disabled' : 'success'} />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title={translate('save')}>
                                        <IconButton className='action-button' size="small" disabled={!editedFlagRef.current} onClick={() => handleClickAction('save')}>
                                            <SaveIcon color={!editedFlagRef.current ? 'disabled' : 'info'} />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title={translate('show_histories')}>
                                        <IconButton className='action-button' size="small" disabled={histories.length === 0} onClick={() => handleClickAction('show-histories')}>
                                            <HistoryIcon color={histories.length === 0 ? 'disabled' : 'warning'} />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                            </Box>}
                        </Box>
                        <Box className='main' sx={{ height: (innerHeight - 64 - 61 - 18) }}>
                            {mode === 1 && 
                            <Box sx={{ position: "relative", height: "100%" }}>
                                <Box className='position-sticky-top backdrop-filter' display="flex" justifyContent="space-between" px={4} py={2}>
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                        <span>{translate('rowsperpage')}:</span>
                                        <FormControl sx={{ mr: 1 }} size="small">
                                            <Select
                                                value={rowsPerPage}
                                                onChange={handleChangeRowsPerPage}
                                                displayEmpty
                                                autoWidth
                                                sx={{ "& > div": { padding: "5px 10px" }, "& > fieldset": { borderColor: "rgb(229, 234, 242)" } }}
                                            >
                                                {[50, 100, 200].map((item, i)=> (
                                                    <MenuItem key={i} value={item}>{item}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                    <Pagination 
                                        shape="rounded" 
                                        count={pageCount}
                                        page={page + 1}
                                        onChange={handleChangePage}
                                        color="primary" 
                                    />
                                </Box>
                                {scripts?.length === 0 &&
                                <Box sx={{ position: "absolute", width: "100%", top: "30%", textAlign: "center" }}>
                                    <SmartToyTwoToneIcon sx={{ fontSize: "200px", color: "#4152691a" }} />
                                    <Typography variant="h5" sx={{ color: "#9999998c", textAlign: "center" }}>
                                    {translate('createyouritemandstartexperimentingnow', { item: "robot" })}
                                    </Typography>
                                </Box>}
                                <Box className='cards'>
                                    {scripts.map((card) => (
                                        <Card key={card.scriptID} className='card'>
                                            <CardContent sx={{ height: 140, padding: "8px 16px 0 16px", }}>
                                                <Box className='card-content'>
                                                    <Box className='card-content-items'>
                                                        <Typography variant="body1" component="div" className="project-name" title={card.projectName}>
                                                            <span class="material-symbols-outlined" style={{ fontSize: 14 }}>folder</span>&nbsp;{card.projectName}
                                                        </Typography>
                                                        <Typography variant="body2" component="div" className="created-user-name" title={`${card.firstName} ${card.firstName}`}>
                                                            <span class="material-symbols-outlined" style={{ fontSize: 14 }}>person</span>&nbsp;{card.firstName}&nbsp;{card.lastName}
                                                        </Typography>
                                                        <Typography variant="body2" component="div" className="script-id" title={card.scriptID}>
                                                            <span class="material-symbols-outlined" style={{ fontSize: 14 }}>numbers</span>&nbsp;{card.scriptID}
                                                        </Typography>
                                                        <Typography variant="h6" component="div" className='title' title={card.name}>
                                                            {card.name}
                                                        </Typography>
                                                        <Typography variant="body2" component="div" className="description" title={card.description} gutterBottom>
                                                            {card.description}
                                                        </Typography>
                                                        <Box display="flex" gap={1}>
                                                            {(card.errorNotificationYN === 1) &&
                                                            <span class="material-symbols-outlined option" style={{ fontSize: 14 }} title={translate('sendinganemailwhenanerroroccurs')}>mail</span>}
                                                            {(card.scheduleYN === 1) &&
                                                            <span class="material-symbols-outlined option" style={{ fontSize: 14 }} title={translate('scheduled')}>schedule</span>}
                                                        </Box>
                                                    </Box>
                                                    <Icon icon={card.icon} color={card.color} bgColor={card.bgColor}/>
                                                </Box>
                                            </CardContent>
                                            <CardActions sx={{ justifyContent: "space-between", p: "0 8px" }}>
                                                <Tooltip title={translate('delete')}>
                                                    <IconButton className='action-button' size="small" onClick={() => handleClickAction('delete', card.scriptID)}>
                                                        <DeleteOutlineOutlinedIcon />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title={translate('duplicate')}>
                                                    <IconButton className='action-button' size="small" onClick={() => handleClickAction('duplicate', card.scriptID)}>
                                                        <CopyAllIcon />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title={translate('run')}>
                                                    <IconButton className='action-button' size="small" onClick={() => handleClickAction('run', card.scriptID)}>
                                                        <PlayCircleFilledWhiteOutlinedIcon sx={{ fontSize: 40 }}/>
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title={translate('update')}>
                                                    <IconButton className='action-button' size="small" onClick={() => handleClickAction('update', card.scriptID)}>
                                                        <DriveFileRenameOutlineIcon />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title={translate('build')}>
                                                    <IconButton className='action-button' size="small" onClick={() => handleClickAction('build', card.scriptID)}>
                                                        <BuildOutlinedIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </CardActions>
                                        </Card>
                                    ))}
                                </Box>
                            </Box>}
                            {mode === 2 && 
                            <ReflexContainer orientation="vertical">
                                <ReflexElement
                                    size="250"
                                    style={{ overflow: "hidden" }}
                                >
                                    <Box>
                                        <Box sx={{ p: 1, borderBottom: "1px solid rgb(229, 234, 242)" }}>
                                            <Box className='search-box' sx={{ p: 0, maxWidth: "1000px" }}>
                                                <IconButton type="submit" sx={{ p: 1 }} aria-label="search">
                                                    <SearchIcon />
                                                </IconButton>
                                                <InputBase
                                                    type="search"
                                                    sx={{ flex: 1 }}
                                                    placeholder={translate('search')}
                                                    fullWidth
                                                    onChange={handleOnChangeSearchStep}
                                                />
                                            </Box>
                                        </Box>
                                        <Box sx={{ overflow: "auto", height: (innerHeight - 64 - 61 - 32 - 61) }}>
                                            {filterCategories(searchStep).map((category, index) => (
                                                <Box key={category.name}>
                                                    <ListItemButton onClick={() => handleClickCategoryExpand(index)}>
                                                        <ListItemText primary={translate(category.name.toLowerCase())} />
                                                        {category.expanded ? <ExpandLess /> : <ExpandMore />}
                                                    </ListItemButton>
                                                    <Collapse in={category.expanded} timeout="auto" unmountOnExit>
                                                        <ReactSortable
                                                            group={{ name: 'steps', pull: 'clone', put: false }}
                                                            list={JSON.parse(JSON.stringify(filterSteps(category.name, searchStep)))} 
                                                            setList={() => {}}
                                                            //Animate
                                                            swapThreshold={10}
                                                            animation={150}
                                                            easing="cubic-bezier(1, 0, 0, 1)"
                                                            sort={false}
                                                            forceFallback={true}
                                                        >
                                                            {filterSteps(category.name, searchStep).map((step) => (
                                                                <ListItemButton
                                                                    key={step.name}
                                                                    dense
                                                                    disableRipple
                                                                    className='cursor-move'
                                                                    sx={{ p: 0.5 }}
                                                                >
                                                                    <ListItemIcon>
                                                                        <span className="material-symbols-outlined step-icon">
                                                                            {step.icon}
                                                                        </span>
                                                                    </ListItemIcon>
                                                                    <ListItemText primary={translate(step.name.toLowerCase())} />
                                                                </ListItemButton>
                                                            ))}
                                                            <Divider />
                                                        </ReactSortable>
                                                    </Collapse>          
                                                </Box>
                                            ))}
                                        </Box>
                                    </Box>
                                </ReflexElement>
                                <ReflexSplitter/>
                                <ReflexElement
                                    sx={{ position: "relative" }}
                                >
                                    <ReflexContainer orientation="horizontal">
                                        <ReflexElement>
                                            <Box className='script-infor'>
                                                <Box>{scriptNameRef.current}</Box>
                                                <Box>{scriptsteps.length}&nbsp;{(scriptsteps.length > 1) ? translate('steps') : translate('step')}</Box>
                                            </Box>
                                            <Box className='steps-block'>
                                                <ReactSortable
                                                    list={scriptsteps}
                                                    setList={setList}
                                                    //Group
                                                    group={{ name: 'steps', pull: 'clone'}}
                                                    //Animate
                                                    swapThreshold={0.5}
                                                    animation={300}
                                                    easing="cubic-bezier(1, 0, 0, 1)"
                                                    forceFallback={true}
                                                    //MultiDrag
                                                    multiDrag
                                                    ghostClass='ghost'
                                                    multiDragKey='CTRL'
                                                    avoidImplicitDeselect={true}
                                                    //Action
                                                    onSelect={onSelect}
                                                    onDeselect={onSelect}
                                                    onSort={onSort}
                                                >
                                                    {scriptsteps?.map((scriptstep, index) => (
                                                        <Box key={`scriptstep-${index}`} className={['steps-content' , (selectedItems.includes(index) ? 'selected' : '')].join(' ')}>
                                                            <CustomDivider index={scriptstep.index} />
                                                            {(scriptstep.name === 'loop' || scriptstep.name === 'foreach') && <Box component="div" className='divider-output-chip' />}
                                                            {/* comment */}
                                                            {scriptstep.name === 'comment'
                                                            ?
                                                            <Box className='step-comment'>
                                                                <FormControl fullWidth variant="standard">
                                                                    <Input
                                                                        type="search"
                                                                        value={scriptsteps[index].title}
                                                                        onChange={(e) => handleChangeStepTitle(e, index)}
                                                                        startAdornment={<span className="material-symbols-outlined step-icon cursor-move">{scriptstep.icon}</span>}
                                                                        placeholder={translate('comment')}
                                                                    />
                                                                </FormControl>
                                                            </Box>
                                                            :
                                                            scriptstep.name === 'if' ||
                                                            scriptstep.name === 'loop' ||
                                                            scriptstep.name === 'foreach'
                                                            ?
                                                            <Box width="100%">
                                                                <Box className={`step-start ${scriptstep.category + (scriptstep.ignore ? ' disabled-step' : '')}`}>
                                                                    <Box display="flex" width="100%">
                                                                        <span className="material-symbols-outlined step-icon cursor-move">
                                                                            {scriptstep.icon}
                                                                        </span>
                                                                        <Divider orientation="vertical" flexItem sx={{ mr: 1 }}/>
                                                                        <FormControl fullWidth variant="standard" className='step-title'>
                                                                            <Input
                                                                                type="search"
                                                                                value={scriptsteps[index].title}
                                                                                onChange={(e) => handleChangeStepTitle(e, index)}
                                                                                sx={{ color: "inherit" }}
                                                                            />
                                                                        </FormControl>
                                                                    </Box>
                                                                    {errorSteps.includes(index) && <PriorityHighIcon color='error' />}
                                                                    <CustomOptions options={scriptstep?.options} />
                                                                    <Box display="flex">
                                                                        <IconButton color='inherit' size="small" onClick={handleOpenStepOption}>
                                                                            <SettingsIcon />
                                                                        </IconButton>
                                                                    </Box>
                                                                </Box>
                                                                {scriptstep?.output?.icon && scriptstep?.output?.key && 
                                                                <Box className='step-output-chip'>
                                                                    <Chip 
                                                                        icon={
                                                                            <span className="material-symbols-outlined chip-icon">{scriptstep?.output?.icon}</span>
                                                                        }
                                                                        label={
                                                                            <strong>{scriptstep?.output?.key}</strong>
                                                                        }
                                                                        size="small"
                                                                        variant="filled"
                                                                        className={`${scriptstep.category + (scriptstep.ignore ? ' disabled-step' : '')}`} 
                                                                    />
                                                                </Box>}  
                                                            </Box>
                                                            :
                                                            scriptstep.name === 'else'
                                                            ?
                                                            <Box width="100%">
                                                                <Box className={`step-else ${scriptstep.category + (scriptstep.ignore ? ' disabled-step' : '')}`}>
                                                                    <Box display="flex" width="100%">
                                                                        <span className="material-symbols-outlined step-icon cursor-move">
                                                                            {scriptstep.icon}
                                                                        </span>
                                                                        <Divider orientation="vertical" flexItem sx={{ mr: 1 }}/>
                                                                        <FormControl fullWidth variant="standard" className='step-title'>
                                                                            <Input
                                                                                type="search"
                                                                                value={scriptsteps[index].title}
                                                                                onChange={(e) => handleChangeStepTitle(e, index)}
                                                                                sx={{ color: "inherit" }}
                                                                            />
                                                                        </FormControl>
                                                                    </Box>
                                                                </Box> 
                                                            </Box>
                                                            :
                                                            scriptstep.name === 'endif' ||
                                                            scriptstep.name === 'endloop' ||
                                                            scriptstep.name === 'endforeach'
                                                            ?
                                                            <Box width="100%">
                                                                <Box className={`step-end ${scriptstep.category + (scriptstep.ignore ? ' disabled-step' : '')}`}>
                                                                    <Box display="flex" width="100%">
                                                                        <span className="material-symbols-outlined step-icon cursor-move">
                                                                            {scriptstep.icon}
                                                                        </span>
                                                                        <Divider orientation="vertical" flexItem sx={{ mr: 1 }}/>
                                                                        <FormControl fullWidth variant="standard" className='step-title'>
                                                                            <Input
                                                                                type="search"
                                                                                value={scriptsteps[index].title}
                                                                                onChange={(e) => handleChangeStepTitle(e, index)}
                                                                                sx={{ color: "inherit" }}
                                                                            />
                                                                        </FormControl>
                                                                    </Box>
                                                                </Box> 
                                                            </Box>
                                                            :
                                                            <Box width="100%">
                                                                <Box className={`step-normal ${scriptstep.category + (scriptstep.ignore ? ' disabled-step' : '')}`}>
                                                                    <Box display="flex" width="100%">
                                                                        <span className="material-symbols-outlined step-icon cursor-move">
                                                                            {scriptstep.icon}
                                                                        </span>
                                                                        <Divider orientation="vertical" flexItem sx={{ mr: 1 }}/>
                                                                        <FormControl fullWidth variant="standard" className='step-title'>
                                                                            <Input
                                                                                type="search"
                                                                                value={scriptsteps[index].title}
                                                                                onChange={(e) => handleChangeStepTitle(e, index)}
                                                                                sx={{ color: "inherit" }}
                                                                            />
                                                                        </FormControl>
                                                                    </Box>
                                                                    {errorSteps.includes(index) && <PriorityHighIcon color='error' />}
                                                                    <CustomOptions options={scriptstep.options} />
                                                                    <Box display="flex">
                                                                        <IconButton color='inherit' size="small" onClick={() => handleOpenStepOption(index)}>
                                                                            <SettingsIcon />
                                                                        </IconButton>
                                                                    </Box>
                                                                </Box>  
                                                                {scriptstep?.output?.icon && scriptstep?.output?.key && 
                                                                <Box className='step-output-chip'>
                                                                    <Chip 
                                                                        icon={
                                                                            <span className="material-symbols-outlined chip-icon">{scriptstep?.output?.icon}</span>
                                                                        }
                                                                        label={
                                                                            <strong>{scriptstep?.output?.key}</strong>
                                                                        }
                                                                        size="small"
                                                                        variant="filled"
                                                                        className={`${scriptstep.category + (scriptstep.ignore ? ' disabled-step' : '')}`} 
                                                                    />
                                                                </Box>}  
                                                            </Box>}
                                                        </Box>
                                                    ))}
                                                </ReactSortable>
                                            </Box>
                                        </ReflexElement>
                                        {showHistories && <ReflexSplitter/>}
                                        {showHistories && 
                                        <ReflexElement
                                            size="200"
                                        >
                                            <TableContainer className='histories-table'>
                                                <Table stickyHeader size="small" sx={{ minWidth: 650 }} >
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell sx={{ minWidth: 200 }}>{translate('id')}</TableCell>
                                                            <TableCell align="center" sx={{ minWidth: 100 }}>{translate('status')}</TableCell>
                                                            <TableCell align="left">{translate('description')}</TableCell>
                                                            <TableCell align="left" sx={{ minWidth: 140 }}>{translate('startdatetime')}</TableCell>
                                                            <TableCell align="left" sx={{ minWidth: 140 }}>{translate('enddatetime')}</TableCell>
                                                            <TableCell align="center">{translate('view')}</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                    {histories.map((row) => (
                                                        <TableRow key={row.ID}>
                                                            <TableCell scope="row">
                                                                {row.historiesID}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                <Typography sx={{color: (row.statusCd === 0 ? 'rgb(208, 219, 10)' : row.statusCd === 1 ? 'success.main' : 'error.main')}} variant="subtitle2">
                                                                {row.statusCd === 0 ? translate('running') : row.statusCd === 1 ? translate('success') : translate('error')}
                                                                </Typography>
                                                            </TableCell>
                                                            <TableCell align="left" sx={{ maxWidth: 300 }}>
                                                                <Box>
                                                                    {row.description?.toString()?.replace(/\\"/g,"\"")
                                                                                                ?.replace(/\\'/g,"\'")
                                                                                                ?.split('\\n')[0]
                                                                    }
                                                                </Box>
                                                            </TableCell>
                                                            <TableCell align="left">{row.startDateTime}</TableCell>
                                                            <TableCell align="left">{(row.statusCd !== 0) ? row.endDateTime : ''}</TableCell>
                                                            <TableCell align="center">
                                                                <IconButton size='small'>
                                                                    <VisibilityIcon size='small' color='secondary' onClick={() => handleViewHistoriesDetails({...row})} />
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </ReflexElement>}
                                    </ReflexContainer>
                                    {scriptsteps?.length === 0 &&
                                    <Box sx={{ position: "absolute", width: "100%", top: "30%", textAlign: "center" }}>
                                        <ListAltTwoToneIcon sx={{ fontSize: "200px", color: "#4152691a" }} />
                                        <Typography variant="h5" sx={{ color: "#9999998c", textAlign: "center" }}>
                                        {translate('createyouritemandstartexperimentingnow', { item: `${translate('script').toLowerCase()}` })}
                                        </Typography>
                                    </Box>}
                                </ReflexElement>
                            </ReflexContainer>
                            }
                        </Box>
                    </Box>
                </Grid>
                <StepOptions 
                    open={openStepOption} 
                    anchorPosition={anchorPosition} 
                    index={indexRef.current} 
                    scriptsteps={scriptsteps}
                    handleClose={handleCloseStepOptions} 
                    handleAgree={handleAgreeStepOptions}
                    handleOpenCalculation={handleOpenCalculation}
                    handleOpenArray={handleOpenArray}
                    handleOpenObject={handleOpenObject}
                />
                <Dialog
                    open={openQuickBuilder}
                    onClose={() => setOpenQuickBuilder(false)}
                    maxWidth="xl"
                    fullWidth
                >
                    <DialogTitle>かんたん作成</DialogTitle>
                    <DialogContent>
                        <Box className="quick-builder">
                            <Box className="quick-builder-panel">
                                <Typography variant="subtitle2">URLを開く</Typography>
                                <Box sx={{ display: "flex", gap: 1 }}>
                                    <InputBase
                                        className="quick-builder-url"
                                        placeholder="https://www.example.com/"
                                        value={quickBuilder.url}
                                        onChange={(e) => setQuickBuilder(prev => ({ ...prev, url: e.target.value }))}
                                    />
                                    <Button variant="contained" disableElevation onClick={handleQuickDisplay}>表示</Button>
                                </Box>
                                <Divider sx={{ my: 2 }} />
                                <Typography variant="subtitle2">操作</Typography>
                                <ToggleButtonGroup
                                    value={quickBuilder.action}
                                    exclusive
                                    fullWidth
                                    size="small"
                                    onChange={(_e, value) => value && setQuickBuilder(prev => ({ ...prev, action: value }))}
                                >
                                    <ToggleButton value="click">クリック</ToggleButton>
                                    <ToggleButton value="typeText">テキスト入力</ToggleButton>
                                    <ToggleButton value="typePassword">パスワード入力</ToggleButton>
                                </ToggleButtonGroup>
                                {(quickBuilder.action === 'typeText' || quickBuilder.action === 'typePassword') &&
                                    <InputBase
                                        className="quick-builder-url"
                                        sx={{ mt: 1 }}
                                        placeholder="入力する内容"
                                        value={quickBuilder.text}
                                        onChange={(e) => setQuickBuilder(prev => ({ ...prev, text: e.target.value }))}
                                    />
                                }
                                <Typography variant="body2" sx={{ mt: 2, color: "text.secondary" }}>
                                    右の画面で対象をクリックすると、ステップに追加されます。
                                </Typography>
                                <Divider sx={{ my: 2 }} />
                                <Typography variant="subtitle2">作成中の流れ</Typography>
                                <Box className="quick-builder-steps">
                                    {quickBuilder.steps?.length ? quickBuilder.steps.map((step, stepIndex) => (
                                        <Box className="quick-builder-step" key={`${step.name}-${stepIndex}`}>
                                            <Box className="quick-builder-step-no">{stepIndex + 1}</Box>
                                            <Box className="quick-builder-step-body">
                                                <Typography className="quick-builder-step-title">{quickStepTitle(step)}</Typography>
                                                <Typography className="quick-builder-step-detail">{quickStepDetail(step)}</Typography>
                                            </Box>
                                        </Box>
                                    )) : (
                                        <Typography variant="body2" sx={{ color: "text.secondary", mt: 1 }}>
                                            まだステップはありません。
                                        </Typography>
                                    )}
                                </Box>
                                {quickBuilder.error &&
                                    <Typography color="error" sx={{ mt: 2 }}>{quickBuilder.error}</Typography>
                                }
                            </Box>
                            <Box className="quick-builder-browser">
                                {quickBuilder.loading &&
                                    <Box className="quick-builder-loading">
                                        <CircularProgress />
                                    </Box>
                                }
                                {!quickBuilder.loading && !quickBuilder.data &&
                                    <Box className="quick-builder-empty">URLを入力して「表示」を押してください。</Box>
                                }
                                {quickBuilder.data &&
                                    <Box sx={{ position: "relative", width: quickBuilder.data.width, height: quickBuilder.data.height }}>
                                        <img
                                            src={`data:image/png;base64,${quickBuilder.data.screenshotBase64}`}
                                            width={quickBuilder.data.width}
                                            height={quickBuilder.data.height}
                                            alt=""
                                            style={{ display: "block" }}
                                        />
                                        {quickBuilder.data.elements?.map((element, elementIndex) => (
                                            <Tooltip key={`${element.selector}-${elementIndex}`} title={`${element.tag}${element.text ? `: ${element.text}` : ''}`}>
                                                <Box
                                                    onClick={() => handleQuickSelectElement(element)}
                                                    sx={{
                                                        position: "absolute",
                                                        left: element.x,
                                                        top: element.y,
                                                        width: element.width,
                                                        height: element.height,
                                                        border: "2px solid #20c7b8",
                                                        background: "rgba(32,199,184,0.10)",
                                                        cursor: "crosshair",
                                                        "&:hover": {
                                                            borderColor: "#ff7a00",
                                                            background: "rgba(255,122,0,0.18)"
                                                        }
                                                    }}
                                                />
                                            </Tooltip>
                                        ))}
                                    </Box>
                                }
                            </Box>
                        </Box>
                    </DialogContent>
                </Dialog>
                <SpecifyCalculationDialog 
                    open={openCalculation}
                    handleClose={handleCloseCalculation}
                    handleAgree={handleAgreeCalculation}
                    scriptsteps={scriptsteps}
                    options={optionsRef.current}
                />
                <ProjectsDialog 
                    open={openProjects}
                    handleClose={handleCloseProjects}
                />
                <ScriptsDialog 
                    open={openScriptsDialog}
                    data={dataScriptRef.current}
                    handleAgree={handleClickAgree}
                    handleClose={handleClickClose}
                    projects={projects}
                    handleOpenProjects={handleClickOpenProjects}
                />
                <HistoriesDetailsDialog 
                    mode={historiesMode}
                    open={openHistoriesDetails}
                    handleClose={handleCloseHistoriesDetails}
                    scriptID={scriptID || scriptIDRef.current}
                    scriptName={scriptNameRef.current}
                    scriptsteps={scriptsteps}
                    hisInfor={hisInforRef.current}
                />
                <ArrayDialog 
                    open={openArray} 
                    onClose={handleCloseArray} 
                    onAgree={handleAgreeArray}
                    scriptsteps={scriptsteps}
                    options={optionsRef.current} 
                />
                <ObjectDialog 
                    open={openObject} 
                    onClose={handleCloseObject} 
                    onAgree={handleAgreeObject}
                    scriptsteps={scriptsteps}
                    options={optionsRef.current} 
                />
            </Grid>
        </Container>
    );
}
function mapStateToProps(state) {
    return {
        BackDrop: state.BackDrop,
        SnackbarAlert: state.SnackbarAlert,
        ConfirmDialog: state.ConfirmDialog,
    }
}
export default connect(mapStateToProps)(withTranslate(Workspace));
